import { ActionKeys } from "./actionTypes";
export const login = (user) => ({
    type: ActionKeys.LOGIN,
    payload: user
});
export const logout = () => ({ type: ActionKeys.LOGOUT });
export const fetchUser = (silent = false) => ({
    type: ActionKeys.FETCH_USER,
    payload: { silent }
});
export const loginPending = () => ({
    type: ActionKeys.LOGIN_PENDING
});
export const logoutPending = () => ({
    type: ActionKeys.LOGOUT_PENDING
});
export const fetchUserPending = () => ({ type: ActionKeys.FETCH_USER_PENDING });
export const setUser = (user) => ({
    type: ActionKeys.SET_USER,
    payload: user
});
export const unsetUser = () => ({
    type: ActionKeys.UNSET_USER
});
export const setError = (error) => ({
    type: ActionKeys.SET_ERROR,
    payload: error
});
export const actions = {
    login,
    logout,
    fetchUser,
    setUser,
    unsetUser,
    setError,
    loginPending,
    logoutPending,
    fetchUserPending
};
//# sourceMappingURL=actions.js.map